/*
服务数据报表
*/
import { getDate } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

// 累计数据概览-服务端格式转客户端
function cvtCumulativeData2Client(result) {
    // 加千位分隔符
    const ret = {};
    for (let key in result) {
        ret[key] = result[key] ? parseInt(result[key]).toLocaleString() : "0";
    }

    return [
        {
            title: i18n.t("zhiji.serviceData.overallClosed"),
            overall: [
                {
                    name: i18n.t("zhiji.serviceData.total"),
                    value: ret.pv
                },
                {
                    name: i18n.t("zhiji.serviceData.userNum"),
                    value: ret.uv
                }
            ],
            partial: []
        },
        {
            title: i18n.t("zhiji.serviceData.ticketHandle"),
            overall: [
                {
                    name: i18n.t("zhiji.serviceData.total"),
                    value: ret.ticket_handle_num
                },
                {
                    name: i18n.t("zhiji.serviceData.userNum"),
                    value: ret.ticket_handle_user
                }
            ],
            partial: [
                {
                    name: i18n.t("zhiji.serviceData.tikArtificialNum"),
                    value: ret.ticket_rengong_num
                },
                {
                    name: i18n.t("zhiji.serviceData.autoHandleNum"),
                    value: ret.ticket_zidong_num
                },
                {
                    name: i18n.t("zhiji.serviceData.urgentTotal"),
                    value: ret.ticket_jinji_num
                }
            ]
        },
        {
            title: i18n.t("zhiji.serviceData.robot"),
            overall: [
                {
                    name: i18n.t("zhiji.serviceData.questionNum"),
                    value: ret.question_num
                },
                {
                    name: i18n.t("zhiji.serviceData.uvLabel"),
                    value: ret.robot_uv
                }
            ],
            partial: [
                {
                    name: i18n.t("zhiji.serviceData.penalizeSearchNum"),
                    value: ret.penalize_num
                },
                {
                    name: i18n.t("zhiji.serviceData.penalizeSearchUser"),
                    value: ret.penalize_user
                }
            ]
        }
    ];
}

// 累计数据概览-客户端格式转服务端
function transCumulativeData2Server(reqData) {
    return {
        channel: reqData.channel,
        date: reqData.date,
        language: reqData.lang
    };
}

// 工单关键指标-服务端格式转客户端
function cvtTiketIndicator2Client(result, reqData) {
    const [green, bule] = ["#46DA93", "#2EC4FF"];
    const [month, week, day] = [i18n.t("zhiji.serviceData.mData"), i18n.t("zhiji.serviceData.wData"), i18n.t("zhiji.serviceData.dData")];

    const yesterDate = `${getDate(new Date(reqData.date), 0, "YYYY/MM/DD")}`;
    const monthDate = `${getDate(new Date(reqData.date), 29, "YYYY/MM/DD")} - ${yesterDate}`;
    const weekDate = `${getDate(new Date(reqData.date), 6, "YYYY/MM/DD")} - ${yesterDate}`;

    return {
        solveData: [
            {
                title: month,
                date: monthDate,
                rate: result.month_bot_solve_rate_print ? parseFloat(result.month_bot_solve_rate_print) : 0,
                color: green
            },
            {
                title: week,
                date: weekDate,
                rate: result.week_bot_solve_rate_print ? parseFloat(result.week_bot_solve_rate_print) : 0,
                color: green
            },
            {
                title: day,
                date: yesterDate,
                rate: result.day_bot_solve_rate_print ? parseFloat(result.day_bot_solve_rate_print) : 0,
                color: green
            }
        ],
        complainData: [
            {
                title: month,
                date: monthDate,
                rate: result.month_complain_rate_print ? parseFloat(result.month_complain_rate_print) : 0,
                color: bule,
                users: result.month_complain_num || "0"
            },
            {
                title: week,
                date: weekDate,
                rate: result.week_complain_rate_print ? parseFloat(result.week_complain_rate_print) : 0,
                color: bule,
                users: result.week_complain_num || "0"
            },
            {
                title: day,
                date: yesterDate,
                rate: result.day_complain_rate_print ? parseFloat(result.day_complain_rate_print) : 0,
                color: bule
            }
        ]
    };
}

// 工单关键指标-客户端格式转服务端
function transTiketIndicator2Server(reqData) {
    return {
        channel: reqData.channel,
        date: reqData.date,
        language: reqData.lang
    };
}

// 数据趋势-服务端格式转客户端
function cvtTiketTrend2Client(result) {
    let ret = {
        xAxisData: [],
        pv: [], // 服务闭环次数
        uv: [], // 服务闭环用户数
        robotUv: [], // 机器人服务闭环用户数
        ticketCreateNum: [], // 工单生成量
        ticketCreateUser: [], // 生成工单用户数
        ticketHandleNum: [], // 工单处理量
        ticketHandleUser: [] // 处理工单用户数
    };

    let list = result.list;

    let xAxisArr = Object.keys(list);
    xAxisArr.sort((a, b) => {
        return new Date(a) - new Date(b);
    });

    for (let index in xAxisArr) {
        for (let i in list) {
            if (xAxisArr[index] == i) {
                ret.xAxisData.push(xAxisArr[index]);
                ret.pv.push(list[i].pv); // 服务闭环次数
                ret.uv.push(list[i].uv); // 服务闭环用户数
                ret.robotUv.push(list[i].robot_uv); // 机器人服务闭环用户数
                ret.ticketCreateNum.push(list[i].ticket_create_num); // 工单生成量
                ret.ticketCreateUser.push(list[i].ticket_create_user); // 生成工单用户数
                ret.ticketHandleNum.push(list[i].ticket_handle_num); // 工单处理量
                ret.ticketHandleUser.push(list[i].ticket_handle_user); // 处理工单用户数
                break;
            }
        }
    }
    return ret;
}

// 数据趋势-客户端格式转服务端
function transTiketTrend2Server(reqData) {
    return {
        channel: reqData.channel,
        language: reqData.lang,
        start_time: reqData.startTime,
        end_time: reqData.endTime
    };
}

// 数据详情-服务端格式转客户端
function cvtTiketDetail2Client(result) {
    let list =
        result.list &&
        result.list.map(item => {
            const ret = {};
            for (let key in item) {
                if (key === "idate" || key === "avg_deal_time") {
                    ret[key] = item[key];
                    continue;
                }
                ret[key] = parseInt(item[key]).toLocaleString();
            }

            return {
                date: ret.idate === "sum" ? i18n.t("zhiji.serviceData.total") : ret.idate, // 日期
                pv: ret.pv, // 闭环次数
                uv: ret.uv, // 闭环用户数
                tikCreateNum: ret.ticket_create_num, // 生成量
                tikCreateUser: ret.ticket_create_user, // 生成用户数
                tikHandleNum: ret.ticket_handle_num, // 处理量
                tikHandleUser: ret.ticket_handle_user, // 处理用户数
                tikArtificialNum: ret.ticket_rengong_num, // 人工处理工单数
                tikAutoNum: ret.ticket_zidong_num, // 自动处理工单数
                tikUrgentNum: ret.ticket_jinji_num, // 紧急工单数
                avgDealTime: ret.avg_deal_time ? ret.avg_deal_time + "h" : "--", // 平均工单闭环时长
                questionNum: ret.question_num, // 机器人提问量
                robotUv: ret.robot_uv, // 服务闭环用户数
                penalizeUser: ret.penalize_user // '处罚工具查询用户数'
            };
        });
    return {
        list,
        total: result.total
    };
}
// 数据详情-客户端格式转服务端
function transTiketDetail2Server(reqData) {
    return {
        channel: reqData.channel,
        language: reqData.lang,
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        page: reqData.page,
        size: reqData.size
    };
}

export default {
    cvtCumulativeData2Client,
    transCumulativeData2Server,
    cvtTiketIndicator2Client,
    transTiketIndicator2Server,
    cvtTiketTrend2Client,
    transTiketTrend2Server,
    cvtTiketDetail2Client,
    transTiketDetail2Server
};
